import Nd1SiteFooter from "./Nd1SiteFooter";
import Nd1SiteNav from "./Nd1SiteNav";
import "../nd1.css";

/**
 * ND1 layout for public job detail pages (`/jobs/:id`).
 */
export default function Nd1JobDetailsShell({ currentUser, children }) {
  const isGuest = !currentUser;

  return (
    <div className="nd1-root nd1-job-detail-page">
      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>
      <Nd1SiteNav />
      {children}
      {isGuest ? <Nd1SiteFooter /> : null}
    </div>
  );
}
